import { EventBus } from "@/EventBus";
import moment from 'moment'

export default {
	data() {
		return {
			//qtdRegistrosPorPagina: configPraca.qtdRegistrosPorPagina, //quantidade de registros que podem ser exibidos no grid a cada paginação
			qtdRegistrosPorPagina: 10, //quantidade de registros que podem ser exibidos no grid a cada paginação
			isPopup: ((document.location.href.search("popup.html") > 0) ? true : false),
			paginaAtual: 0, //no caso de paginação, começar a exibir pela página 1
			flagCarregando: false,
			totalRegistros: 0, //total de registros que vieram do banco
			pageOptions: [5, 10, 15], //combo com quantidade de regostros que podem ser exibidos
		}
	},

	methods: {
		executaLogOff() {
			// location.href = configPraca.urlLoginSecurity;
		},

		carregaStoreModules() {
			const store = this.$store;

			const context = require.context('@/store', true, /Store.js$/i);
			context.keys().map(context).map(m => m.default).forEach((resource) => {
				if (!store.state[resource.name])
					store.registerModule(resource.name, resource)
			})
		},

		/** 
		 *	Trata o os erros no sistema
		 */
		trataErro(erro) {
			var objParam = {}
			var fncCallBack = function () { }

			if (erro.response != undefined) {
				objParam.titulo = this.$t('erro.titulo.http')

				if (erro.response.status == 401) {
					objParam.descricao = `${this.$t('erro.erro')}: ${erro.response.status} \n ${this.$t('erro.token_invalido')}`
					fncCallBack = this.executaLogOff
				} else {
					objParam.descricao = `${this.$t('erro.erro')}: ${erro.response.status} \n ${erro.response.error}. ${erro.response.message}`;
				}
			} else {
				objParam.titulo = this.$t('erro.erro')
				objParam.descricao = `${this.$t('erro.erro')}: ${erro.message}`
			}

			this.criaModalMensagem(objParam, fncCallBack, false);
		},

		/** 
		 *	Trata o BreadCrumb
		 */
		configBreadCrumb(params, manterInfoDadoSalvo) {
			let parametroDadosSalvo = (this.$store.getters.getBreadCrumbInfoDadosSalvo ? (this.$store.getters.getBreadCrumbInfoDadosSalvo.id != null ? this.$store.getters.getBreadCrumbInfoDadosSalvo : null) : null);

			this.$store.commit("setBreadCrumb", params);
			if (manterInfoDadoSalvo) {
				this.$store.commit("setBreadCrumbInfoDadosSalvo", parametroDadosSalvo);
			}
		},

		/** 
		 *	Modal com a tela de mensagem
		 */
		criaModalMensagem(objParam, callback, item) { //Modal com a tela de mensagem
			
			this.$bvModal.msgBoxOk(objParam.descricao, {
				noCloseOnBackdrop: true,
           		noCloseOnEsc: true,
				title: objParam.titulo,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				headerClass: 'p-2 border-bottom-0',
				footerClass: 'p-2 border-top-0',
				centered: true
			}).then(value => {
				if (callback && value == true) { //executando a função retorno
					callback(item)
				}
			}).catch(err => {
				console.log(`Erro em BaseMixin - criaModalMensagem: ${err}`)
			})
		},

		criaModalMensagemModalInicial(objParam, callback, item) { 
			
			this.$bvModal.msgBoxOk(objParam.descricao, {
				noCloseOnBackdrop: true,
           		noCloseOnEsc: true,
				title: objParam.titulo,
				size: 'lg',
				buttonSize: 'lg',
				okVariant: 'success',
				headerClass: 'p-2 border-bottom-0',
				centered: true
			}).then(value => {
				if (callback && value == true) { 
					callback(item)
				}
			}).catch(err => {
				console.log(`Erro em BaseMixin - criaModalMensagem: ${err}`)
			})
		},

		

		formatDate(value) {
			return moment(String(value)).format(this.$t("system.date_format"));
		},

		formatDateTime(value) {
			return moment(String(value)).format(this.$t('system.date_time_format'));
		},

		validaVazio(att) {
			return att === null || typeof att === "undefined" || att === "";
		},

		/** Modal com a tela de confirmação de mensagem */
		criaModalConfirm(objParam, callback, item) {
			this.$bvModal.msgBoxConfirm(objParam.descricao, {
				noCloseOnBackdrop: true,
           		noCloseOnEsc: true,
				title: objParam.titulo,
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: this.$t('label.sim'),
				cancelTitle: this.$t('label.nao'),
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value == true) { //executando a função retorno
					callback(item)
				}
			}).catch(err => {
				console.log(`Erro em BaseMixin - criaModalConfirm: ${err}`)
			})
		},

		confirmaExclusao(item, textField = 'descricao') {
			var objParam = {
				titulo: this.$t("label.aviso"),
				descricao: this.$t("msg.valida_apagar") + ` ${item[textField]} ?`
			};
			this.criaModalConfirm(objParam, this.excluir, item);
		},

		/** 
		 * função que é executada após seleção de item do grid de consulta (modo janela PopUp)
		 */
		retornaPopUpSelecaoGrid(objRetorno) {
			self.dataRetorno = objRetorno;
			this.$emit('close');
			self.close();
		},

		limpaPesquisa() {
			this.filtro = {};
			EventBus.$emit('reset-pagina')
		},

		pesquisar() {
			EventBus.$emit('reset-pagina')
		},

		/**Métodos padrão */
		async pesquisarDadosGrid(pagina = 0) {
			if (window.app.service == undefined) {
				console.log('Você precisa declarar a variavel service no data() do componente, apontando qual service irá invocar');
			}
			var service = window.app.service;
			var filtro = window.app.filtro;
			var ordenacao = window.app.ordenacao;

			this.paginaAtual = pagina;
			window.app.paginaAtual = pagina;
			this.tabelaCarregando = true;
			await service.findByFilterPaginated(filtro, this.paginaAtual, window.app.qtdRegistrosPorPagina, ordenacao).then(
				response => {
					if (response) {
						this.tabelaCarregando = false;
						this.dados = response.content;
						this.totalRegistros = response.total ? response.total : response.totalElements;
					}
				},
				error => {
					window.app.trataErro(error);
				}
			);
		},

		serialize(obj) {
			var str = [];
			for (var p in obj)
				if (obj.hasOwnProperty(p)) {
					str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
				}
			return str.join("&");
		},

		

		/**Método que, após gravar alguma informação, dá um set no breadCrumb e redireciona para algum local, caso precise 
		 * id: id do dado salvo - importante para poder tornar a editar o mesmo, caso necessário
		 * descricao: Texto que irá ser exibido na tarja verde da lingueta salvar
		 * urlRedirecionar: Caso seja necessário redirecionar para outra página(componente), colocar o "name" do componente destino do vueRouter
		 */
		gravadoComSucesso(id, objDescricao, urlRedirecionar) {
			this.$store.dispatch("setBreadCrumbInfoDadosSalvo", {
				id: id,
				descricao: objDescricao
			});
			if (urlRedirecionar != undefined && urlRedirecionar != null && urlRedirecionar != "") {
				this.$router.push({
					name: urlRedirecionar
				});
			}
		},

		novo() {
			this.$router.push({
				name: 'novo'
			})
			return false
		},

		voltar() {
			this.$store.dispatch('historicoStore/voltaHistorico')
		},

		clearEvents() {
			EventBus.$off('NOVO');
			EventBus.$off('VOLTAR');
			EventBus.$off('SALVAR');
			EventBus.$off('AVANCAR');
		}
	},

	mounted() { //Criando os botões clicáveis que estão no BreadCrumb
		this.clearEvents();

		EventBus.$on('NOVO', clickCount => {
			this.novo()
			return false
		});
		EventBus.$on('VOLTAR', clickCount => {
			this.voltar();
			return;
		});
		EventBus.$on('SALVAR', clickCount => {
			this.salvar();
			return;
		});
		EventBus.$on('AVANCAR', clickCount => {
			this.avancar();
			return;
		});
		EventBus.$on('LOADING', clickCount => {
			this.flagCarregando = true;
			return;
		});
		EventBus.$on('UNLOADING', clickCount => {
			this.flagCarregando = false;
			return;
		});
	},

	beforeDestroy() { //Destruindo os botões. Isso é super necessário pra não ficar loopando infinitamente nos EventBus.
		this.clearEvents();
	},

	created() {
		window.app = this; //tornando o vue deste componente visível pelo javascrpt mesmo acessando externamente
	}
}